// Stories List ***************************************************************************************
// pathname: /v1/stories
// ************************************************************************************************
import {
  useSwrInfiniteApi,
} from '@hooks/useSwrApi';
import { STORIES_TO_SHOW } from 'src/constants';


// Interface
// ********************************************
interface JobListCardsInfiniteSwrProps {
  locale?: string;
  serverSideData?: ApiSchema<'ResumeStoriesResult'>;
  prioritisedSlug?: string;
}


/**
 * @description SWR: fetch job list cards with infinite pagination.
 *
 * * **locale**: string. What locale to use for the request.
 * * **serverSideData**: ResumeStoriesResult, optional. The data we got from the server side request (if we do it). Default undefined.
 */
export const useSwrStoriesFetchAll = (props: JobListCardsInfiniteSwrProps) => {
  // Props destructuring
  // ********************************************
  const {
    locale,
    serverSideData,
    prioritisedSlug,
  } = props;


  // Get data from API
  // ********************************************
  const {
    data,
    error,
    size,
    setSize,
    isValidating,
    isLoading,
    mutate,
    isEmpty,
    showLoadMore,
    sizeAsRef,
  } = useSwrInfiniteApi<ApiSchema<'ResumeStoriesResult'>>({
    url: '/v1/stories',
    locale,
    serverSideData,
    urlParams: `${prioritisedSlug ? `&ps=${prioritisedSlug}` : ''}`,
    infiniteConfig: {
      limit: STORIES_TO_SHOW,
      // the key where the array of items is located in the response
      responseArrayKey: 'items',
    },
    apiOptions: {
      keepPreviousData: true,
      revalidateOnFocus: false,
      dedupingInterval: 1000 * 60, // 1 minute
    },
    toastsOptions: {
      showErrorToast: true,
    },
  });


  // Return data
  // ********************************************
  return {
    data,
    error,
    size,
    setSize,
    isValidating,
    isLoading,
    mutate,
    isEmpty,
    showLoadMore,
    sizeAsRef,
  };
};
